/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PassedInputs */

const en_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passed`)
};

const fr_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réussi`)
};

const de_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestanden`)
};

const it_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passato`)
};

const ru_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прошедший`)
};

const es_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobado`)
};

const zh_cn2_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过`)
};

const ja_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合格した`)
};

const hi_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उत्तीर्ण`)
};

const pt_pt2_passed = /** @type {(inputs: PassedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovado`)
};

/**
* | output |
* | --- |
* | "Passed" |
*
* @param {PassedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const passed = /** @type {((inputs?: PassedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PassedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_passed(inputs)
	if (locale === "de") return de_passed(inputs)
	if (locale === "it") return it_passed(inputs)
	if (locale === "ru") return ru_passed(inputs)
	if (locale === "es") return es_passed(inputs)
	if (locale === "zh-CN") return zh_cn2_passed(inputs)
	if (locale === "ja") return ja_passed(inputs)
	if (locale === "hi") return hi_passed(inputs)
	if (locale === "pt-PT") return pt_pt2_passed(inputs)
	return en_passed(inputs)
});